// extracted by mini-css-extract-plugin
module.exports = {"plant":"style_plant__3OslX"};